import React from 'react';
import { generateArcPoints, circleFrom3Points } from '../../utils/geometry';

/**
 * Bogen-Vorschau während Arc-Tool aktiv ist.
 * Zeigt eine Vorschau des entstehenden Bogens basierend auf den
 * bereits ausgewählten Punkten und der Mausposition.
 */
export function ArcPreview({ pendingPointIds, points, mousePosition, activeTool }) {
  // Nur im Arc-Tool anzeigen
  if (activeTool !== 'arc') return null;
  if (!mousePosition) return null;

  // Punkte aus pendingPointIds holen
  const pendingPoints = pendingPointIds
    .map(pid => points.find(p => p.id === pid))
    .filter(Boolean);

  // Bei 2 ausgewählten Punkten: Vorschau-Bogen zur Maus zeichnen
  if (pendingPoints.length === 2) {
    const p1 = pendingPoints[0];
    const p2 = pendingPoints[1];
    const p3 = mousePosition;

    // Prüfen ob Kreis möglich ist
    const circle = circleFrom3Points(p1, p2, p3);
    if (!circle) {
      // Punkte sind kollinear - einfache Linie zeichnen
      return (
        <line>
          <bufferGeometry>
            <bufferAttribute
              attach="attributes-position"
              count={3}
              array={new Float32Array([
                p1.x, p1.y, 10,
                p2.x, p2.y, 10,
                p3.x, p3.y, 10
              ])}
              itemSize={3}
            />
          </bufferGeometry>
          <lineBasicMaterial color="#22c55e" linewidth={2} transparent opacity={0.6} />
        </line>
      );
    }

    // Bogen-Punkte generieren
    const arcPoints = generateArcPoints(p1, p2, p3, 16);
    const positions = arcPoints.flatMap(ap => [ap.x, ap.y, 10]);

    return (
      <group>
        {/* Bogen-Vorschau */}
        <line>
          <bufferGeometry>
            <bufferAttribute
              attach="attributes-position"
              count={arcPoints.length}
              array={new Float32Array(positions)}
              itemSize={3}
            />
          </bufferGeometry>
          <lineBasicMaterial color="#22c55e" linewidth={2} transparent opacity={0.6} />
        </line>

        {/* Kreismittelpunkt markieren */}
        <mesh position={[circle.cx, circle.cy, 10]}>
          <circleGeometry args={[50, 16]} />
          <meshBasicMaterial color="#22c55e" transparent opacity={0.3} />
        </mesh>
      </group>
    );
  }

  // Bei 1 ausgewähltem Punkt: Nur Linie zum zweiten Punkt
  if (pendingPoints.length === 1) {
    const p1 = pendingPoints[0];
    return (
      <line>
        <bufferGeometry>
          <bufferAttribute
            attach="attributes-position"
            count={2}
            array={new Float32Array([
              p1.x, p1.y, 10,
              mousePosition.x, mousePosition.y, 10
            ])}
            itemSize={3}
          />
        </bufferGeometry>
        <lineBasicMaterial color="#22c55e" linewidth={1} transparent opacity={0.5} />
      </line>
    );
  }

  return null;
}

export default ArcPreview;
